import { Link } from "react-router-dom";
import { LegalPage } from "../../components/public/LegalPage";

export const TermsConditions = () => {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms & Conditions"
      description="The rules for using PassEnglishTest, including payments, refunds and your account."
    >
      <p>
        Welcome to PassEnglishTest, a web application specifically designed for
        CELPIP test preparation. By accessing and using our services, you agree
        to the following terms and conditions. These terms govern the use of our
        platform, detailing user rights, responsibilities, and legal guidelines.
        We recommend that you read them thoroughly before using our services.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing our platform, you agree to comply with and be bound by
        these Terms & Conditions. If you do not agree with these terms, you are
        prohibited from using our services. Your continued use of the platform
        constitutes acceptance of any changes made to these terms.
      </p>

      <h2>2. Use of Platform</h2>
      <p>
        Our platform is designed for legal use only. You are responsible for
        ensuring that your use of the platform complies with all applicable laws
        and regulations. Any misuse of the platform, including attempts to gain
        unauthorized access or introducing malicious software, will result in
        immediate termination of access and may lead to legal action.
      </p>
      <p>
        Additionally, we reserve the right to alter, modify, or remove any
        content on the platform without prior notice. While we strive to
        maintain a bug-free and secure platform, we cannot guarantee that the
        platform will always be free from errors or interruptions.
      </p>

      <h2>3. Intellectual Property Rights</h2>
      <p>
        All content, graphics, logos, layout, design, and infographics on this
        website are protected by intellectual property laws. Unauthorized use or
        reproduction of this content is strictly prohibited and will be subject
        to legal action. The intellectual property rights associated with our
        platform remain our sole property, and users are not granted any rights
        to modify or distribute this content without prior written consent.
      </p>

      <h2>4. AI-Powered Scoring and Feedback</h2>
      <p>
        The AI-powered scoring for Writing and Speaking sections is based on the
        CELPIP scoring guide. While our system aims to provide accurate and
        consistent evaluations, we do not guarantee that the scores provided
        will match your official CELPIP test results. Our AI system is designed
        as a supplementary tool to help you prepare effectively, but it is not a
        substitute for official CELPIP assessments.
      </p>

      <h2>5. Security</h2>
      <p>
        We manage secure data networks designed to protect your personal
        information. We use all reasonable precautions to safeguard your data,
        but under certain circumstances, we reserve the right to disclose your
        information to trusted third parties or partners for legal purposes or
        to enhance our services. Despite our efforts, we cannot guarantee that
        our platform will be completely free from security breaches or
        unauthorized access.
      </p>
      <p>
        We provide secure gateways for any debit/credit card transactions.
        However, it is your responsibility to ensure that your financial
        information is handled securely. Any issues arising from payment
        processing should be addressed with your financial institution.
      </p>

      <h2>6. Refund Policy</h2>
      <p>
        We do not offer refunds once a purchase has been made. Digital goods are
        categorized differently under Consumer Contracts Regulations and do not
        offer the same protections as physical goods. Once a purchase is
        completed, it is final, and no switching between products or packages is
        permitted.
      </p>
      <p>
        Account deletions are permanent, and any remaining subscription time or
        services will be forfeited. Users are responsible for ensuring that they
        understand and agree to this policy before making any purchases.
      </p>

      <h2>7. Cancellation of Account</h2>
      <p>
        If you choose to cancel your account, all access to the platform will be
        revoked. Account deletions are permanent, and any remaining subscription
        time or services will be forfeited. Deleting your account will not
        entitle you to a refund for any unused portion of the package you
        purchased.
      </p>

      <h2>8. Cookies</h2>
      <p>
        Our platform uses cookies to enhance your user experience. Cookies are
        small text files that are stored on your device to help us improve our
        services and provide personalized content. You can manage your cookie
        preferences through your browser settings, but please note that some
        features of our website may not function properly if cookies are
        disabled.
      </p>

      <h2>9. Third-Party Links</h2>
      <p>
        Our platform may contain links to third-party websites. These links are
        provided for your convenience, but we do not control or endorse the
        content or privacy practices of these websites. We encourage you to
        review the terms and privacy policies of any third-party websites you
        visit. We are not responsible for any harm or damage resulting from your
        use of these third-party websites.
      </p>

      <h2>10. Modification of Terms</h2>
      <p>
        We reserve the right to modify or update these terms at any time without
        prior notice. Your continued use of the platform constitutes acceptance
        of any changes made. It is your responsibility to review these terms
        periodically to stay informed about any updates or modifications.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions or concerns about these Terms & Conditions,
        please contact us through our{" "}
        <Link to="/contact-us">Contact Us page</Link>. We are here to help and
        provide any necessary clarifications regarding our terms and your rights
        as a user of our platform.
      </p>
    </LegalPage>
  );
};
